import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { marketList } from '../../model/constants/marketContants';
import { RootState } from '../store';


interface GlobalConfigState {
    market: string;
    locale: string;
    language: string;
    translateWithAi: boolean;
    translateWithAiMarket: string;
}

const initialState: GlobalConfigState = {
    market: '',
    locale: 'en',
    language: 'English',
    translateWithAi: false,
    translateWithAiMarket: '',
};

const globalConfigSlice = createSlice({
    name: 'globalConfig',
    initialState,
    reducers: {
        setMarket: (state, action: PayloadAction<string>) => {
            console.log('Setting market:', action.payload);
            document.cookie = `lng=${action.payload}; path=/; domain=${process.env.REACT_APP_COOKIE_LNG_DOMAIN?.toString()};`;
            state.market = action.payload;
            state.locale = marketList[action.payload]?.locale;
        },
        setLocale: (state, action: PayloadAction<string>) => {
            state.locale = action.payload;
        },
        setToggleTranslateWithAi: (state, action: PayloadAction<boolean>) => {
            if(action.payload){
                document.cookie = `laerdalsupport-translate-with-ai=true; path=/;`;
                document.cookie = `laerdalsupport-market=${state.market}; path=/;`;
                state.translateWithAi = true;
                state.translateWithAiMarket = state.market;
            }
            else{
                document.cookie = `laerdalsupport-translate-with-ai=false; path=/;`;
                document.cookie = `laerdalsupport-market=; path=/;`;
                state.translateWithAi = false;
                state.translateWithAiMarket = '';
            }
        },
        setTranslateWithAi: (state, action: PayloadAction<boolean>) => {
            document.cookie = `laerdalsupport-translate-with-ai=${action.payload}; path=/;`;
            state.translateWithAi = action.payload;
        },
        setTranslateWithAiMarket: (state, action: PayloadAction<string>) => {
            document.cookie = `laerdalsupport-market=${action.payload}; path=/;`;
            state.translateWithAiMarket = action.payload;
        }
    }
});

// Selectors
export const selectMarket = (state: RootState) => state?.globalConfig?.market;
export const selectMarketPath = (state: RootState) => {
    if(!state?.globalConfig?.market) 
        return '';

    return '/' + state?.globalConfig?.market;
};
export const selectLocale = (state: RootState) => state?.globalConfig?.locale;
export const selectTranslateWithAi = (state: RootState) => state?.globalConfig?.locale && state?.globalConfig?.translateWithAiMarket === state?.globalConfig?.market;

// Helper function to build market-aware paths
export const buildMarketPath = (market: string | undefined, path: string): string => {
    return market ? `/${market}${path}` : path;
};

export const { setMarket, setLocale, setTranslateWithAi, setTranslateWithAiMarket, setToggleTranslateWithAi } = globalConfigSlice.actions;
export default globalConfigSlice.reducer;
